export const SDK_VERSION = '7.118.0';
